window.account = {
    setup () {
        // Nothing
    },

    /**
     * Submit Account Form
     *
     * @param event
     */
    submitAccountForm: function (event) {
        event.preventDefault();

        //
        // Clear Error Messages
        //
        let errorMapping = {
            'salutation': 'salutation',
            'first_name': 'first-name',
            'last_name': 'last-name',
            'phone_number': 'phone-number',
            'newsletter_subscription': 'newsletter-subscription',
        };

        for (let i = 0; i < Object.keys(errorMapping).length; i++) {
            let value = errorMapping[Object.keys(errorMapping)[i]];
            document.querySelector('[data-error-' + value +']').style.display = 'none';
            document.querySelector('[data-error-' + value +']').innerText = '';
        }

        $.ajax({
            url: window.loginEndpoint + '/profile',
            type: 'POST',
            headers: {Authorization: 'Bearer ' + window.authorisation.getToken()},
            data: {
                salutation: document.querySelector('[data-input-salutation]').value,
                first_name: document.querySelector('[data-input-first-name]').value,
                last_name: document.querySelector('[data-input-last-name]').value,
                phone_number: document.querySelector('[data-input-phone-number]').value,
                newsletter_subscription: document.querySelector('[data-checkbox-newsletter-subscription]').checked ? 'yes' : 'no',
            },
            success: () => {
                // Get the value of the URL parameter redirect_url
                let queryString = window.location.search;
                let urlParams = new URLSearchParams(queryString);
                let redirectUrl = urlParams.get('redirect_url');

                if (redirectUrl) {
                    window.location = window.loginEndpoint + '/sso/refresh' + '?redirect_url=' + redirectUrl;
                } else {
                    window.location = window.loginEndpoint + '/sso/refresh' + '?redirect_url=' + encodeURIComponent(window.location.href + '?updated=true')
                }
            },
            error: (result) => {
                //
                // If we received errors, present them
                //
                for (let i = 0; i < Object.keys(errorMapping).length; i++) {
                    let key = Object.keys(errorMapping)[i];
                    let value = errorMapping[Object.keys(errorMapping)[i]];

                    if (key in result.responseJSON) {
                        let message = result.responseJSON[key].join('. ');
                        document.querySelector('[data-error-' + value +']').style.display = 'block';
                        document.querySelector('[data-error-' + value +']').innerText = message
                    }
                }

            },
        });
    },
}
